import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';
import { getOneUpEndpointCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useOneUpEndpoint', {
    errorLoading: 'Error loading endpoint',
});

export type UseOneUpEndpointArgs = {
    endpointId: number | string;
};

export type UseOneUpEndpointReturnValue = {
    isLoading: boolean;
    endpoint: APITypes.ehrIntegrationsService.OneUpHealthEndpointWithDisabledStatus;
};

export default function useOneUpHealthEndpoint({ endpointId }: UseOneUpEndpointArgs): UseOneUpEndpointReturnValue {
    const endpointQuery = useQuery({
        queryKey: getOneUpEndpointCacheKey(endpointId),

        queryFn: async () => {
            return await appAPI.get(urls.api.ehrIntegrations.oneUpHealth.endpoints.endpoint(Number(endpointId)));
        },
        enabled: !!endpointId,
    });
    useQueryErrorNotify(endpointQuery, intl('errorLoading'));

    return {
        isLoading: endpointQuery.isLoading,
        endpoint: endpointQuery.data?.endpoint || null,
    };
}
